import { useCallback } from "react";
import { RuleGroupType } from "@common/types/transactionRule";
import { createRulesUrl } from "@components/settings/Rules/lib/rulesUrl";
import { useStateAwareNavigate } from "./useStateAwareNavigate";

interface GoToAccountRulesParams {
    accountIds: string[];
    entityIds: number[];
}

export function useGoToAccountRules() {
    const navigate = useStateAwareNavigate();

    return useCallback(
        ({ accountIds, entityIds }: GoToAccountRulesParams) => {
            navigate(
                createRulesUrl({
                    tab: RuleGroupType.ACCOUNTING,
                    filters: {
                        ledgerAccountIds: accountIds,
                        entityIds: Array.from(new Set(entityIds)),
                    },
                }),
            );
        },
        [navigate],
    );
}
